import { UseContextProps } from 'models';
import { useContextAction } from 'hooks/useContextAction';
import { SxProps, TableCell, TableCellProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

export interface TableClickableCellProps extends TableCellProps {
  contextAction: UseContextProps;
  onClick: () => void;
}

export default function TableClickableCell({
  contextAction,
  onClick,
  ...props
}: TableClickableCellProps) {
  const { isAllowed: canSeeDetail } = useContextAction({
    actionCode: contextAction.actionCode,
    resourceEntity: contextAction?.resourceEntity,
    entityIdentificator: contextAction?.entityIdentificator
  });

  const cellProps: SxProps<Theme> | undefined = canSeeDetail
    ? {
        cursor: 'pointer',
        ...props.sx
      }
    : { ...props.sx };

  return (
    <TableCell
      onClick={() => {
        if (canSeeDetail) {
          onClick();
        }
      }}
      {...props}
      sx={cellProps}
    />
  );
}
